import { render, staticRenderFns } from "./OccurrenceActionModal.vue?vue&type=template&id=3af498bc"
import script from "./OccurrenceActionModal.vue?vue&type=script&lang=js"
export * from "./OccurrenceActionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3af498bc')) {
      api.createRecord('3af498bc', component.options)
    } else {
      api.reload('3af498bc', component.options)
    }
    module.hot.accept("./OccurrenceActionModal.vue?vue&type=template&id=3af498bc", function () {
      api.rerender('3af498bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/lesson/OccurrenceActionModal.vue"
export default component.exports